import React from 'react';
export function Footer() {
  return <footer className="w-full py-12 px-4 md:px-8 bg-warmBrown text-cream/80 mt-12" data-id="element-93">
      <div className="max-w-3xl mx-auto text-center" data-id="element-94">
        <p className="text-sm md:text-base font-serif leading-relaxed" data-id="element-95">
          <strong data-id="element-96">Disclaimer:</strong> Dies ist ein persönlicher
          Erfahrungsbericht. Ergebnisse können individuell variieren. Bei
          anhaltenden Beschwerden bitte immer einen Tierarzt aufsuchen.
        </p>
        <div className="mt-8 pt-8 border-t border-cream/20 text-xs opacity-60" data-id="element-97">
          &copy; {new Date().getFullYear()} Napftagebuch. Alle Rechte
          vorbehalten.
        </div>
      </div>
    </footer>;
}